<template>
  <div
    @click="handleClick()"
    :class="radio"
    role="radio"
    :aria-checked="isSelected.toString()"
    @keydown="handleKeyDown"
    tabindex="0"
  >
    <slot>Base tab header</slot>
  </div>
</template>

<script>
const SPACEBAR = 32;

export default {
  props: {
    value: {
      required: true,
      type: Number
    }
  },
  computed: {
    classObject: function() {
      return {
        selected: this.isSelected
      };
    },

    isSelected: function() {
      const { value: currentValue } = this.getSingleSelectState();
      return currentValue === this.value;
    }
  },

  methods: {
    handleClick() {
      const { set } = this.getSingleSelectState();
      set(this.value);
    },

    handleKeyDown(event) {
      if (event.keyCode === SPACEBAR) {
        this.handleClick();
        event.preventDefault();
      }
    }
  },
  inject: ["getSingleSelectState"]
};
</script>

<style lang="scss" scoped>
.selected {
  color: green;
}
</style>